import * as angular from "angular";
import * as _ from "lodash";
import * as PhoneFormat from "phoneformat.js";
import {IQService} from "angular";
import {SplitService} from "./split-service.service";
import {SitesRequestsService} from "../../sites/services/sites-requests.service";

export class PhoneAndEmailFactoryService {

  constructor(private IamService, private $q: IQService, private $filter, private $log,
              private sitesRequestsService: SitesRequestsService, private splitService: SplitService) {
  }

  isPhoneOrEmailChanged(payloadCopy, role) {
    let modifiedUser = _.get(payloadCopy, 'user'),
      currentUser = _.get(role, 'user');

    if (modifiedUser && currentUser) {
      return this.isEmailChanged(modifiedUser.email, currentUser.email) || this.isPhoneChanged(modifiedUser.mobilePhone, currentUser.mobilePhone);
    } else {
      this.$log.error('Modified user object or current user object not found!. \n ' +
        '--> accountDialogService@editShipper@isPhoneOrEmailChanged');
    }

  }

  validatePhoneAndEmail(payloadCopy, role) {

    const deferred = this.$q.defer();

    let modifiedUser = _.get(payloadCopy, 'user'),
      currentUser = _.get(role, 'user'),
      email = this.isEmailChanged(modifiedUser.email, currentUser.email) ? _.get(modifiedUser, 'email') : null,
      mobilePhone = this.isPhoneChanged(modifiedUser.mobilePhone, currentUser.mobilePhone) ? _.get(modifiedUser, 'mobilePhone') : null;

    if (!_.isNull(mobilePhone)) {
      mobilePhone = this.$filter('bringozPhonePrefix')(mobilePhone);
    }

    this.IamService.validateUserPhoneAndEmail(email, mobilePhone).then(
      (_validationResult) => {

        let isValidPhone = _.get(_validationResult, 'data.isValidPhone'),
          isValidEmail = _.get(_validationResult, 'data.isValidEmail');

        if (_.isUndefined(isValidPhone)) {
          isValidPhone = true
        }

        if (_.isUndefined(isValidEmail)) {
          isValidEmail = true
        }

        if (isValidPhone && isValidEmail) {

          deferred.resolve();

        } else {
          deferred.reject({
            isValidPhone: isValidPhone,
            isValidEmail: isValidEmail
          });
        }

      }
    );

    return deferred.promise;
  }

  validatePhoneAndEmailOnCreate(payloadCopy) {
    const deferred = this.$q.defer();

    let email = _.get(payloadCopy.user, 'email'),
      mobilePhone = _.get(payloadCopy.user, 'mobilePhone');

    mobilePhone = this.$filter('bringozPhonePrefix')(mobilePhone);

    this.IamService.validateUserPhoneAndEmail(email, mobilePhone).then(
      (_validationResult) => {

        let isValidPhone = _.get(_validationResult, 'data.isValidPhone'),
          isValidEmail = _.get(_validationResult, 'data.isValidEmail');

        if (_.isUndefined(isValidPhone)) {
          isValidPhone = true
        }

        if (_.isUndefined(isValidEmail)) {
          isValidEmail = true
        }

        if (isValidPhone && isValidEmail) {

          deferred.resolve();

        } else {
          deferred.reject({
            isValidPhone: isValidPhone,
            isValidEmail: isValidEmail
          });
        }

      }
    );

    return deferred.promise;

  }

  isEmailChanged(modifiedUserEmail, currentUserEmail) {
    return !_.isEqual(modifiedUserEmail, currentUserEmail);
  }

  isPhoneChanged(modifiedUserPhone, currentUserPhone) {
    const modifiedPhone = this.$filter('bringozPhonePrefix')(modifiedUserPhone);
    const currentPhone = this.$filter('bringozPhonePrefix')(currentUserPhone);
    return !_.isEqual(modifiedPhone, currentPhone);
  }

  phoneFormValidation(mobilePhone, country, form, fieldName) {
    if (_.isUndefined(mobilePhone)) {
      form[fieldName].$setValidity('valid', false);
      return;
    }

    const siteId = this.splitService.getSiteId();
    this.sitesRequestsService.validatePhoneNumber(siteId, mobilePhone, country)
      .then((res) => {
        form[fieldName].$setValidity('valid', res.isValid);
      })
      .catch(() => {
        form[fieldName].$setValidity('valid', false);
      })
  }

  phoneFormValidationAndExists(mobilePhone, country, form, fieldName) {

    if (_.isUndefined(mobilePhone)) {
      form[fieldName].$setValidity('valid', false);
      form[fieldName].$setValidity('exists', false);
      return;
    }

    // Phone Validation
    let siteId = this.splitService.getSiteId();
    this.sitesRequestsService.validatePhoneNumber(siteId, mobilePhone, country)
      .then((res) => {
        form[fieldName].$setValidity('valid', res.isValid);
      })
      .catch((error) => {
        this.$log.debug('Fail to validate phone number', error);
        form[fieldName].$setValidity('valid', false);
      })

    // Exists Validation
    const validMobilePhone = PhoneFormat.formatLocal(country, mobilePhone);
    const formattedE164MobilePhone = PhoneFormat.formatE164(country, validMobilePhone);

    this.IamService.validateUserPhone(formattedE164MobilePhone)
      .then((isValid) => {
        form[fieldName].$setValidity('exists', isValid);
      })
      .catch((error) => {
        this.$log.debug('Fail to validate user mobilePhone', error);
        form[fieldName].$setValidity('exists', true);
      })


    // if(valid){
    //    form[fieldName].$setValidity('valid', true);
    //
    //    var validMobilePhone = PhoneFormat.formatLocal(country, mobilePhone);
    //    var formatedE164MobilePhone = PhoneFormat.formatE164(country, validMobilePhone);
    //
    //    IamService.validateUserPhone(formatedE164MobilePhone)
    //    .then(function(isValid) {
    //       form[fieldName].$setValidity('exists', isValid);
    //    })
    //    .catch(function(error) {
    //       $log.debug('Fail to validate user mobilePhone', error);
    //    })
    //
    // } else {
    //    form[fieldName].$setValidity('valid', false);
    //    form[fieldName].$setValidity('exists', true);
    // }

  }

  emailFormValidation(email, form, fieldName) {
    this.IamService.validateUserEmail(email)
      .then((isValid) => {
        form[fieldName].$setValidity('exists', isValid);
      })
      .catch((error) => {
        this.$log.debug('Fail to validate user email', error);
      })
  }


  // Phone Validation
  phoneValidation(mobilePhone, country) {
    let siteId = this.splitService.getSiteId();
    return this.sitesRequestsService.validatePhoneNumber(siteId, mobilePhone, country)
  }

  // Phone Exist Validation
  phoneExistValidation(mobilePhone, country) {
    const validMobilePhone = PhoneFormat.formatLocal(country, mobilePhone);
    const formattedE164MobilePhone = PhoneFormat.formatE164(country, validMobilePhone);

    return this.IamService.validateUserPhone(formattedE164MobilePhone);
  }

}

angular
  .module('bringoz.admin.commons')
  .service('phoneAndEmailFactoryService', PhoneAndEmailFactoryService);
